import React, {PropTypes} from 'react'
import {connect} from 'react-redux'
import SelectWrap from '../shared/select/SelectWrap'
import {updateSubscribers, setAppModule, showContactModal} from 'state/actions'
import styles from './subscribe.scss'
import {isEqual} from 'lodash/lang'
import c from 'state/constants'
import i18n from 'lib/i18n'

const _ = i18n('agendaPopup')

@connect(null, {updateSubscribers, setAppModule, showContactModal})
export default class Subscribe extends React.Component {
	static propTypes = {
		dateId: PropTypes.string.isRequired,
		updateSubscribers: PropTypes.func.isRequired,
		onClose: PropTypes.func.isRequired,
		subscriberOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
		capacity: PropTypes.number.isRequired,
		activeSubscribers: PropTypes.array.isRequired,
		placesLeft: PropTypes.number.isRequired,
		setAppModule: PropTypes.func,
		showContactModal: PropTypes.func,
	}
	constructor(props) {
		super(props)
		const {activeSubscribers, subscriberOptions} = props

		const initialState = []
		for (const subscriber of subscriberOptions) {
			if (activeSubscribers.includes(subscriber.value)) {
				initialState.push(subscriber)
			}
		}

		this.state = { list: initialState }
	}
	handleSelectChange(list) {
		this.setState({list: [...list]})
	}
	updateSubscribers() {
		const {dateId} = this.props
		const {list} = this.state

		const subscriberIds = list.map(subscriber => subscriber.value)

		this.props.updateSubscribers(subscriberIds, dateId)
	}

	render() {
		const {onClose, subscriberOptions, capacity, activeSubscribers, placesLeft, setAppModule, showContactModal} = this.props
		const {list} = this.state
		const chosenUsers = Array.isArray(list) ? list.length : (list.length && list.split(",").length)
		const placesOccupied = capacity - (activeSubscribers.length + placesLeft)
		const freePlaces = capacity - (placesOccupied + chosenUsers)
		const isFull = (placesOccupied + chosenUsers) > capacity
		return (
			<div className={styles.registerDialogContainer}>
				<div className={styles.registerDialog}>
					<div className={styles.description}>{_('description')}</div>
					<div className={styles.subscriberContainer}>
						<div className={styles.dropdownContainer}>
							<div className={styles.iconConatiner}>
								<img src={require('resources/images/a-people_2x.png')}/>
							</div>
							<div className={styles.subscriberDropdown}>
								<SelectWrap
									options={subscriberOptions}
									onChange={(e) => this.handleSelectChange(e)}
									value={list}
									placeholder={_('selectUsers')}
									backspaceRemovesValue={false}
									blurInputOnSelect
									isMulti
								/>
							</div>
						</div>
						<div className={styles.bottomContainer}>
							<div className={styles.freePlacesContainer}>
								<div className={styles.freePlaces}>
									{`${_('freePlaces')}: ${freePlaces < 0 ? 0 : freePlaces}`}
								</div>
							</div>
							<div className={styles.buttonContainer}>
								<div className={styles.buttonContainerLeft}>
									<button
										onClick={() => {
											setAppModule(c.OFFICE, 'contacts')
											showContactModal(null)
										}}
										className={styles.greyButton}
									>{_('addNewContact')}</button>
								</div>
								<div className={styles.buttonContainerRight}>
									<button
										onClick={onClose}
										className={`${styles.closeBtn} ${styles.greyButton}`}
									>{_('close')}</button>
									<button
										disabled={isFull}
										onClick={() => {
											if (!isEqual(list, activeSubscribers)) {
												this.updateSubscribers()
											}
											onClose()
										}}
										className="btn green"
									>{_('confirm')}</button>
								</div>
							</div>
						</div>
					</div>
					<div className={styles.closeCross}>
						<span onClick={onClose} className={styles.cross}>×</span>
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/agenda/subscribe.jsx